import React from "react";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";

export const SearchBarDesktop = ({ dataSearch, setDataSearch, onSearch }) => {
  const onChangeDate = (field) => (value) => {
    setDataSearch({
      ...dataSearch,
      [field]: value ? formatDayMonth(value) : "",
    });
  };

  var tuNgay = currentDate();
  if (dataSearch.tuNgay === "01/01/2001") tuNgay = "";
  else tuNgay = dataSearch.tuNgay;
  var denNgay = currentDate();
  if (dataSearch.denNgay === "01/01/4000") denNgay = "";
  else denNgay = dataSearch.denNgay;
  denNgay = convertDate(denNgay);
  tuNgay = convertDate(tuNgay);

  return (
    <>
      <div className="row">
        <div className="col-lg-2 col-md-6 col-sm-12">
          <div className="form-group">
            <label className="font-color-default font-bold">Tìm kiếm</label>
            <input
              type="text"
              className="form-control"
              placeholder="Nhập mã, tên hoặc SDT"
              value={dataSearch.sSearch}
              onChange={(e) =>
                setDataSearch({ ...dataSearch, sSearch: e.target.value })
              }
            />
          </div>
        </div>
        <div className="col-lg-2 col-md-6 col-sm-10">
          <div className="form-group">
            <label className="font-color-default font-bold">
              Loại hợp đồng
            </label>
            <select
              className="form-control"
              value={dataSearch.sLoaiHopDong}
              onChange={(e) =>
                setDataSearch({ ...dataSearch, sLoaiHopDong: e.target.value })
              }
            >
              <option value="-1">Tất cả</option>
              <option value="3">Cầm đồ</option>
              <option value="1">Tín chấp</option>
              <option value="2">Trả góp</option>
              <option value="4">Bán hàng trả góp</option>
              <option value="5">Huy động vốn</option>
            </select>
          </div>
        </div>
        <div className="input-sm-new input-new-10">
          <label className="font-color-default font-bold">Từ ngày</label>
          <DateTimePicker
            value={tuNgay}
            onChange={onChangeDate("tuNgay")}
            placeholder="Từ ngày"
            name="tuNgay"
          ></DateTimePicker>
        </div>
        <div className="input-sm-new input-new-10">
          <label className="font-color-default font-bold">Đến ngày</label>
          <DateTimePicker
            value={denNgay}
            onChange={onChangeDate("denNgay")}
            placeholder="Đến ngày"
            name="denNgay"
          ></DateTimePicker>
        </div>
        <div className="col-lg-2 col-md-6 col-sm-10">
          <div className="form-group">
            <label className="font-color-default font-bold">Trạng thái</label>
            <select
              className="form-control"
              value={dataSearch.sTrangThai}
              onChange={(e) =>
                setDataSearch({ ...dataSearch, sTrangThai: e.target.value })
              }
            >
              <option value="-2">Tất cả</option>
              <option value="2">Đã ký số</option>
              <option value="-1">Đã hủy</option>
            </select>
          </div>
        </div>
        <div className="input-sm-new input-new-18 search-main-new">
          <button
            type="submit"
            className="btn btn-info-new btn-seach-ds"
            onClick={onSearch}
          >
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
      {/* <div className="row">
        <div className="col-lg-3 col-md-6 col-sm-12">
          <div className="form-group">
            <label>Từ ngày</label>
            <input
              type="date"
              className="form-control"
              value={dataSearch.TuNgay}
              onChange={(e) =>
                setDataSearch({ ...dataSearch, TuNgay: e.target.value })
              }
            />
          </div>
        </div>
        <div className="col-lg-3 col-md-6 col-sm-12">
          <div className="form-group">
            <label>Đến ngày</label>
            <input
              type="date"
              className="form-control"
              value={dataSearch.DenNgay}
              onChange={(e) =>
                setDataSearch({ ...dataSearch, DenNgay: e.target.value })
              }
            />
          </div>
        </div>
      </div> */}
    </>
  );
};
